<template>
  <div class="mt-4">
    <filter-bar
      @dailySearch="handleSearch"
      v-if="classInfo.status"
    ></filter-bar>
    <div class="md-layout">
      <div class="md-layout-item content">
        <template>
          <Detail
            ref="detail"
            :detail="detail"
            :percentStudent="percentStudent"
          ></Detail>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import FilterBar from "./FilterBar.vue";
import Detail from "./Detail.vue";
import { service_paths } from "@/constants/Services";
import moment from "moment";
import { convertTimeByTimezone } from "@/helpers/datetime-helper";
import { mapGetters, mapState } from "vuex";
import { hasValidRole } from "../../../../helpers/role-helper";
import Role from "@/constants/Role";
import { getId } from "../../../../helpers/utils";
import { ISIS_FORMAT } from "@/helpers/datetime-helper";

const clientLocale = localStorage.getItem("language");
const formatDateClient =
  clientLocale === "en" ? "MM-DD-YYYY hh:mm a" : "DD-MM-YYYY hh:mm a";

export default {
  name: "attendance-list",
  props: ["classInfo"],
  components: {
    FilterBar,
    Detail
  },
  data() {
    return {
      detail: {},
      queryParams: {},
      percentStudent: ""
    };
  },
  computed: {
    ...mapGetters("user", {
      userTz: "timezone",
      userRole: "role"
    }),
    ...mapState("switchAccountChild", ["currentChild"])
  },
  methods: {
    formatDateTime(date, userTimeZone) {
      return convertTimeByTimezone(
        date,
        "Etc/UTC",
        userTimeZone ?? moment.tz.guess(),
        formatDateClient
      );
    },
    convertDate(item) {
      let date = new Date();
      const currentDate = moment(date).format(ISIS_FORMAT.date);
      item.date = this.formatDateTime(item.date, this.userTz);
      const attendanceDate = moment(item.date).format(ISIS_FORMAT.date);
      if (attendanceDate !== currentDate && !item.status) {
        item.status = "unchecked";
      }
    },
    async handleSearch(queryParams) {
      if (hasValidRole(this.userRole, Role.Family)) {
        queryParams.children_id = getId(this.currentChild);
      } else {
        delete queryParams.student_id;
      }
      queryParams.class_status = this.classInfo.status;
      this.queryParams = queryParams;
      let percentStudent = await this.$axios
        .get(
          `${service_paths.attendances}/percent-student`,
          queryParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => response.data);
      delete percentStudent.sum_number_student;
      this.percentStudent = percentStudent;
      let detail = await this.$axios
        .get(`${service_paths.reports}/attendance/daily-attendance`, {
          ...queryParams,
          limit: 999
        })
        .then(response => response.data);
      Object.values(detail.attendance).forEach(attendance => {
        attendance.forEach(item => {
          this.convertDate(item);
        });
      });
      let dataMerge = {};
      for (let item in detail.attendance) {
        dataMerge[item] = {
          attendance: detail.attendance[item]
        };
      }
      Object.entries(detail.meta_data).map(meta => {
        dataMerge[meta[0]].date = meta[0];
        dataMerge[meta[0]] = Object.assign(dataMerge[meta[0]], meta[1]);
      });
      let sortedData = Object.entries(dataMerge).sort((a, b) => {
        if (a > b) return -1;
        if (a < b) return 1;
        return 0;
      });
      this.detail = sortedData;
    },
    injectFormData() {}
  }
};
</script>
<style lang="scss" scoped></style>
